import {Component} from 'react';
import PropTypes from 'prop-types';

import SharePopoverPanel from '../SharePopoverPanel';
import CopyableFormControl from '../CopyableFormControl';

export default class EmbedSection extends Component {
	UNSAFE_componentWillMount() {
		if (!this.props.linkObj) {
			this.props.getLink();
		}
	}

	render() {
		const {linkObj, expanded, expandSection} = this.props;

		if (!linkObj) {
			return null;
		}

		return (
			<SharePopoverPanel title="Copy the embed code below to add to your website." expanded={expanded} onClick={expandSection}>
				<form>
					<div className="form-group">
						<span className="small">Copy the embed code below to add to your website.</span>
					</div>
					<CopyableFormControl value={linkObj.link} />
				</form>
			</SharePopoverPanel>
		);
	}
}

EmbedSection.propTypes = {
	expanded: PropTypes.bool,
	linkObj: PropTypes.shape({
		link: PropTypes.string,
		id: PropTypes.number,
		version: PropTypes.number
	}),
	getLink: PropTypes.func.isRequired,
	expandSection: PropTypes.func.isRequired
};

EmbedSection.defaultProps = {
	expanded: false
};